import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardHeader, CardMedia, Grid2, Link, Stack, TextField, Typography } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

// const COURSES = [
//   {
//     slug: 'practicerange',
//     title: 'Practice Range',
//     url: 'https://coursedata.opengolfsim.com/simulator/remote/universal/practicerangeurp/v15/practicerange2_urp.webgl.unity3d',
//     gameMode: 0
//   },
//   {
//     slug: 'island_range_game',
//     title: 'Island Range Game',
//     url: 'https://coursedata.opengolfsim.com/simulator/remote/universal/rangegameurp/v15/rangegame_urp.webgl.unity3d',
//     gameMode: 1
//   }
// ];
export default function Simulator() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [players, setPlayers] = useState([
    {
      name: 'Web Test',
      id: 'web_test',
      clubs: [
        {
          name: 'Driver',
          id: 'DR',
          distance: 210,
        },
        {
          name: 'Putter',
          id: 'PT',
          distance: 0,
        }
      ]
    }
  ]);
  const [courses, setCourses] = useState([]);

  const handleCourseClick = useCallback((course) => {
    console.log('course', course);
    const gameData = {
      courseUrl: course.courseUrl,
    }
    const setupData = {
      players,
      // gameMode: course.gameMode,
      // isRemoteBundle: true,
      shotsPerRound: 5,
      roundsPerGame: 5,
      mouseMode: false,
      cameraOffset: 0,
      parentWindowTitle: 'none',
      parentWindowHwnd: 0,
      units: 'imperial',
      puttingEnabled: false,
      elevation: 0
    }
    navigate('/simulation', { state: { setupData, gameData: course } });
  }, [players, navigate]);

  const fetchCourses = async () => {
    const res = await auth.request('/api/library/home?platform=web');
    console.log(res.data);
    setCourses(res.data.courses);
  }

  useEffect(() => {
    fetchCourses();
  }, []);
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2, flex: 0 }}>
        Web Simulator
      </Typography>
      <Typography sx={{ mb: 4 }} color="textSecondary">
        Our web simulator is an experimental way to experiment with the <Link href="https://opengolfsim.com/simulator">FUSE engine</Link>, right in the browser.{' '}
        For the full experience, <Link href="https://opengolfsim.com/download">download</Link> our fully-featured desktop or mobile app to connect launch monitors, capture swing videos, track shot data, and more.
      </Typography>
      <Grid2 container={true} spacing={3}>
        {courses.map(course => (
          <Grid2 size={3} key={course.slug}>
            <Card variant="outlined" sx={{ p: 0 }}>
              <CardActionArea onClick={() => handleCourseClick(course)}>
                <CardHeader title={course.title} sx={{ p: 2 }} slotProps={{ title: { sx: { fontSize: 15 }}}} />
                <CardMedia image={course.posterUrl} sx={{ height: 150 }} />
              </CardActionArea>
              <CardActions>
                <Button onClick={() => handleCourseClick(course)} fullWidth={true}>Launch</Button>
              </CardActions>
            </Card>
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
}